'use es6';

import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getEventValue } from '../../../utils/jsEventUtils';
import { SHARE_EMAIL, RECURRING_OPTION, SEND_NOW_OPTION } from '../shareTypes';
import { useControlsContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCadenceLabels = currentDialog => {
  switch (currentDialog) {
    case SHARE_EMAIL:
      return {
        headerText: 'reporting-action-components.actions.emailReport.dialog.form.emailCadenceOptions.optionGroupLabel',
        singleSendOption: 'reporting-action-components.actions.emailReport.dialog.form.emailCadenceOptions.singleEmail',
        recurringOption: 'reporting-action-components.actions.emailReport.dialog.form.emailCadenceOptions.recurringEmail',
        singleSendTestId: 'email-report-send-now',
        recurringTestId: 'email-report-schedule-email'
      };
    default:
      return {
        headerText: 'reporting-action-components.actions.shareVia.dialog.form.cadenceOptions.optionGroupLabel',
        singleSendOption: 'reporting-action-components.actions.shareVia.dialog.form.cadenceOptions.singleMessage',
        recurringOption: 'reporting-action-components.actions.shareVia.dialog.form.cadenceOptions.recurringMessage',
        singleSendTestId: 'slack-report-send-now',
        recurringTestId: 'slack-report-schedule-email'
      };
  }
};
const ShareCadenceOptions = () => {
  const {
    currentDialog,
    shareCadence,
    setShareCadence
  } = useControlsContext();
  const {
    headerText,
    singleSendOption,
    recurringOption,
    singleSendTestId,
    recurringTestId
  } = getCadenceLabels(currentDialog);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: headerText
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "shareType",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        checked: shareCadence === SEND_NOW_OPTION,
        value: SEND_NOW_OPTION,
        onChange: e => {
          setShareCadence(getEventValue(e));
        },
        "data-test-id": singleSendTestId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: singleSendOption
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        checked: shareCadence === RECURRING_OPTION,
        value: RECURRING_OPTION,
        onChange: e => {
          setShareCadence(getEventValue(e));
        },
        "data-test-id": recurringTestId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: recurringOption
        })
      })]
    })
  });
};
export default ShareCadenceOptions;